import {IntermediatePart} from "../../intermediatePart";
import {getCurrentRoomType} from "../../../../appLayout";
import {LOOK_ROOM_TYPES, VANITY_TYPES} from "../../constants";

export default class VanityCommon extends IntermediatePart {

  constructor(props) {
    super(props);
  }

  getArrayOfConditions() {
    const vanityParent = this.getParent();
    let conditions = super.getArrayOfConditions(); //roomLayout
    let vanitySize = vanityParent.counterTopSize(this);
    if (this.partId === "vanity_mirror" || this.partId === "vanity_lighting") {
      const currentVanityTypeFeatureGroup = vanityParent.relatedItems.find(relItem => relItem.partId === vanityParent.vanity_type);
      if (currentVanityTypeFeatureGroup && currentVanityTypeFeatureGroup.layerPositions) {
        if (vanitySize === "24" || (Array.isArray(vanitySize) && vanitySize.includes("24"))) {
          if (currentVanityTypeFeatureGroup.layerPositions["L"] && currentVanityTypeFeatureGroup.layerPositions["R"]) {
            conditions.push({
              propName: "MirrorShape",
              propValue: "24D"
            });
          } else if (currentVanityTypeFeatureGroup.layerPositions["C"]) {
            conditions.push({
              propName: "MirrorShape",
              propValue: "24S"
            });
          }
        }
      }
    }
    if (this.partId === "vanity_backsplash") {
      const activeSideMeta = vanityParent.getActiveMatchingMetaFromRelatedItem(vanityParent.vanity_type, "Side");
      if (activeSideMeta && activeSideMeta.includes("C")) {
        conditions.push({
          propName: "Side",
          propValue: activeSideMeta
        });
      }
    }
    if (vanitySize && (getCurrentRoomType() === LOOK_ROOM_TYPES.as)
        && !(this.partId === "vanity_countertop" && vanityParent.vanity_type !== VANITY_TYPES.vanity_cabinet)) {
      conditions.push({
        propName: "VanitySize",
        propValue: vanitySize
      })
    }
    return conditions
  }

  matchesMetaForCondition(...props) {
    if (this.partId === "vanity_mirror" || this.partId === "vanity_lighting") {
      const [name, value] = props;
      if (name === "MirrorShape") {
        if ((value === "24S") && Array.isArray(this.metaData["MirrorShape"])
          && (this.metaData["MirrorShape"].includes("24RS") || this.metaData["CustomMirrorShapeNoSize"] === "24S")) {
          // mirrors with the MirrorShape 24RS should match with 24S Vanities (they are rounded mirrors, 24RS is needed for round crop wall matching)
          return true
        } else if ((value === "24D") && Array.isArray(this.metaData["MirrorShape"])
          && (this.metaData["MirrorShape"].includes("24RD") || this.metaData["CustomMirrorShapeNoSize"] === "24D")) {
          // mirrors with the MirrorShape 24RD should match with 24D Vanities (they are rounded mirrors, 24RD is needed for round crop wall matching)
          return true
        }
      }
    }
    return super.matchesMetaForCondition(...props);
  }

}
